import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=58dddb20&scoped=true"
import script from "./Step1.vue?vue&type=script&lang=js"
export * from "./Step1.vue?vue&type=script&lang=js"
import style0 from "./Step1.vue?vue&type=style&index=0&id=58dddb20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dddb20",
  null
  
)

export default component.exports